:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  --back-btn-position: 10px;
  background: var(--white-layout-301-level-0-elevation);
}

.header__actions {
  display: flex;
}

.footer__container {
  display: flex;
  justify-content: space-between;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.action-button-text,
.action-icon {
  vertical-align: middle;
}

.action-icon {
  display: inline-block;

  &:before {
    font-size: 32px;
  }
}

gz-button[class='action-button']::part(button) {
  padding-right: var(--spacer);
}

.network-sub-tasks {
  position: absolute;
  z-index: auto;
  top: 0;
  left: 0;
}
